import { NetworkError, deepCamelCase, Select, intoSnakeCase } from '../../../fetchers/_helpers';
import {
  LiveInteractionRoomStatusFields,
  LiveInteractionRoomStatus,
} from '../../../models/components/schemas/live-interaction-room-status/LiveInteractionRoomStatus';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type GetInteractionRoomRoomIdStatusFields = readonly LiveInteractionRoomStatusFields[];

/** Options for GET /interaction_rooms/{room_type}/{room_id}/status */
export type GetInteractionRoomRoomIdStatusOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  /** Available fields on the response type, application/vnd.vimeo.live.interaction_room_status */
  select: Paths;
  where: {
    /**
     * The type of the interaction room.
     *
     * Option descriptions:
     *  * `live_event` - The room type is an event.
     *  * `venue` - The room type is a venue.
     *
     */
    roomType: `live_event` | `venue`;
    /**
     * The ID of the interaction room.
     */
    roomId: string;
  };
};

/** Result type for GET /interaction_rooms/{room_type}/{room_id}/status */
export type GetInteractionRoomRoomIdStatusResult<Paths extends readonly string[]> = Select<
  LiveInteractionRoomStatus,
  Paths
>;

/**
 * Get the current status of an interaction room
 * This method returns the current status of the specified interaction room.
 */
export async function getInteractionRoomRoomIdStatus<
  Paths extends GetInteractionRoomRoomIdStatusFields,
>({
  baseUrl,
  select,
  where: { roomType, roomId },
  ...options
}: GetInteractionRoomRoomIdStatusOptions<Paths>): Promise<
  GetInteractionRoomRoomIdStatusResult<Paths>
> {
  let res = await fetch(
    `${baseUrl}/interaction_rooms/${roomType}/${roomId}/status?fields=${select
      .map(intoSnakeCase)
      .join(',')}`,
    {
      ...options,
      method: 'GET',
    },
  );

  if (!res.ok) {
    throw new NetworkError('A network error occurred', res.status, res);
  }

  if (res.status === 204) {
    return null as unknown as GetInteractionRoomRoomIdStatusResult<Paths>;
  }

  if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
    throw new Error('Expected JSON response');
  }

  let json = await res.json();
  return deepCamelCase(json);
}
